import ShelfPane from './ShelfPane'

export default ShelfPane
// eslint-disable-next-line import/export
export * from './ShelfPane'
